// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

import { SocketProvider } from "./providers/Socket";
import { PeerManagerProvider } from "./providers/PeerManager";
import { AdminProvider } from "./admin/AdminContext";

import Homepage from "./pages/Home";
import RoomPage from "./pages/RoomPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SocketProvider>
          <PeerManagerProvider>
            <AdminProvider>
              <Routes>
                <Route path="/" element={<Homepage />} />
                <Route path="/room/:roomId" element={<RoomPage />} />

                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </AdminProvider>
          </PeerManagerProvider>
        </SocketProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
